import { IKeHoachMon } from './../../../model/respone/ke-hoach/IKeHoachMon';
import { IKeHoachMonSelectViewRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectViewRequest";
import { IKeHoachMonVmDetail } from "../../../model/respone/ke-hoach/IKeHoachMonVmDetail";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { IKeHoachMonChiTietSaveRequest } from '../../../model/request/ke-hoach/IKeHoachMonChiTietSaveRequest';
import { IKeHoachMonChiTiet } from '../../../model/respone/ke-hoach/IKeHoachMonChiTiet';
import { IIdsRequest } from '../../../model/request/IIdsRequest';
import { IKeHoachMonNVGhepLopModal } from '../../reducer-model/ke-hoach/IKeHoachMonNVReducer';
import { IKeHoachPhamVi } from '../../../model/respone/ke-hoach/IKeHoachPhamVi';
import { IKeHoachGhepLopRequest } from '../../../model/request/ke-hoach/IKeHoachGhepLopRequest';

export const eKeHoachMonNVActionsObj = {

    CHANGE_FILTER: {} as IKeHoachMonSelectViewRequest,
    LOAD_START: {} as IKeHoachMonSelectViewRequest,
    LOAD_SUCCESS: {} as IKeHoachMonVmDetail[],
    LOAD_ERRR: "",

    UPDATE_KHM_START: {} as IKeHoachMon[],
    UPDATE_KHM_SUCCESS: {} as IKeHoachMon[],
    UPDATE_KHM_ERROR: "",

    SAVE_CHITIET_START: {} as IKeHoachMonChiTietSaveRequest,
    SAVE_CHITIET_SUCCESS: {} as IKeHoachMonChiTiet[],
    SAVE_CHITIET_ERROR: "",

    DELETE_CHITIET_START: {} as IIdsRequest,
    DELETE_CHITIET_SUCCESS: {} as number[],
    DELETE_CHITIET_ERROR: "",

    CHANGE_GHEP_LOP_MODAL: {} as IKeHoachMonNVGhepLopModal|undefined,

    UPDATE_GHEP_LOP_START: {} as IKeHoachGhepLopRequest,
    UPDATE_GHEP_LOP_SUCCESS: {} as IKeHoachPhamVi[],
    UPDATE_GHEP_LOP_ERROR: "",

};
export const eKeHoachMonNVActionIds = generateActionTypeIds(
    eKeHoachMonNVActionsObj,
    "KE_HOACH_MON_NV"
);
export type IKeHoachMonNVActionTypes = IGenericActionType<
    typeof eKeHoachMonNVActionsObj,
    "KE_HOACH_MON_NV"
>;
